import { render, staticRenderFns } from "./mArtist.vue?vue&type=template&id=27c337f9&scoped=true"
import script from "./mArtist.vue?vue&type=script&lang=js"
export * from "./mArtist.vue?vue&type=script&lang=js"
import style0 from "./mArtist.vue?vue&type=style&index=0&id=27c337f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c337f9",
  null
  
)

export default component.exports